import React, { useState } from 'react'
import { Facebook, Instagram, SocialMedia, Tiktok } from '../helpers/Helper'
import { HeaderContainer, Logo, Toggle, Bar, Nav, NavList, NavItem, Link, NavLogo, NavSocial, HeaderMax } from './headerStyle'
import UseLink from './useLink'

export default function Header() {

  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(!open)
  const handleClose = () => setOpen(false)
  UseLink()

  return (
    <HeaderContainer>
      <HeaderMax>
        <Logo>
          Cluckin'Bell
        </Logo>
        <Toggle onClick={handleOpen}>
          <Bar isOpen={open}></Bar>
          <Bar isOpen={open}></Bar>
          <Bar isOpen={open}></Bar>
        </Toggle>
        <Nav isOpen={open}>
          <NavList>
            <NavItem>
              <Link href='#home' 
                className='home active' 
                onClick={handleClose}
              >Inicio</Link>
            </NavItem>
            <NavItem>
              <Link href='#menu' 
                className='menu' 
                onClick={handleClose}
              >Menú</Link>
            </NavItem>
            <NavItem>
              <Link href='#office' 
                className='office' 
                onClick={handleClose}
              >Sucursales</Link>
            </NavItem>
            <NavItem>
              <Link href='#contact' 
                className='contact' 
                onClick={handleClose}
                >Contacto</Link>
            </NavItem>
          </NavList>
          <NavSocial>
            <NavLogo/>
            <SocialMedia>
              <Facebook/>
              <Instagram/>
              <Tiktok/>
            </SocialMedia>
          </NavSocial>
        </Nav>
      </HeaderMax>
      
    </HeaderContainer>
  )
}
